export default __webpack_public_path__ + "static/media/chevron.78647bbb.svg";